<script>
    import { t } from "../../scripts/i18n";
    export let text = $t('Clean notification block text');
    export let hideBtnLabel = $t('Clean notification submit button label');
    export let show = true;

    function hide() {
        show = !show;
    }
</script>

{#if show}
    <div class="notification-block">
        <p class="message-background-p">
            {@html text}
        </p>
        <button class="btn btn-info btn-lg" on:click={hide}>
            {hideBtnLabel}
        </button>
    </div>
{/if}

<style>
    .notification-block {
        display: flex;
        align-items: center;
        padding: 0px 24px;
        border: 1px solid #8001bd;
        border-radius: 20px;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 25px;
    }

    .notification-block .message-background-p {
        font-family: "Roboto";
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 16px;
        color: #000;
        max-width: 770px;
        margin-bottom: 0;
        display: inline-block;
    }

    .btn-lg {
        padding: 17px 54px;
    }
    .btn-info {
        border: none;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        transition: all 1s ease;
        background: #8001bd;
        box-shadow: 0 4px 4px rgba(0,0,0,.25);
        border-radius: 11px;
        color: #fff;
        font-family: Roboto;
    }
</style>